import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { formatDiscountPrice, formatTaxPrice, formatTaxPercent, formatSubtotalPrice } from '@/utils/pricing';
import { useTranslate } from '@/hooks/useTranslate';

export const PriceDetails = () => {
  const { pricing } = useContext(CheckoutContext);
  const { t } = useTranslate();

  const showDiscount = Boolean(pricing.priceBreakdown.discount);
  const isTaxValid = pricing.priceBreakdown.isTaxValid;
  const discountRatePoints = pricing.priceBreakdown.discountRatePoints ?? 0;
  // Text color is inherited from the parent `<Details>` container, which auto-
  // contrasts against the publisher hero (white on image, black on plain BG)
  // via `useDetailsContentColor`. No per-row color logic needed here.
  return (
    <div data-testid="price-details" className="flex flex-col gap-2 text-sm">
      <div className="flex justify-between">
        <div>{t('subtotal')}</div>
        <div data-testid="price-subtotal">{formatSubtotalPrice(pricing.priceBreakdown, pricing)}</div>
      </div>
      {showDiscount && (
        <div className="flex justify-between">
          <div>
            {t('discount')}
            {discountRatePoints ? ` (${discountRatePoints}%)` : ''}
          </div>
          <div data-testid="price-discount">{formatDiscountPrice(pricing.priceBreakdown, pricing)}</div>
        </div>
      )}
      <div className="flex justify-between">
        <div data-testid="price-tax-label">
          {t('tax')}
          {isTaxValid ? ` (${formatTaxPercent(pricing.priceBreakdown)})` : ''}
        </div>
        <div data-testid="price-tax">{formatTaxPrice(pricing.priceBreakdown, pricing)}</div>
      </div>
    </div>
  );
};
